import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTest } from '../../contexts/TestContext';
import { emotionalAreas } from '../../config/areas';
import AreaCard from './AreaCard';
import './AreaSelection.css';

const AreaSelection = () => {
  const navigate = useNavigate();
  const { setSelectedArea } = useTest();
  
  const handleAreaSelect = (areaId) => {
    setSelectedArea(areaId);
    navigate(`/quiz/${areaId}`);
  };
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.1
      }
    }
  };
  
  return (
    <div className="area-selection-container">
      <motion.div 
        className="area-selection-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1>¿En qué área sientes más malestar actualmente?</h1>
        <p>Selecciona una opción para continuar con preguntas específicas sobre ese tema.</p>
      </motion.div>
      
      <motion.div 
        className="area-cards-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {emotionalAreas.map((area) => (
          <AreaCard 
            key={area.id}
            area={area}
            onSelect={() => handleAreaSelect(area.id)}
          />
        ))}
      </motion.div>
      
      <motion.div 
        className="back-button-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
      >
        <button 
          className="back-button"
          onClick={() => navigate('/')}
        >
          Volver
        </button>
      </motion.div>
    </div>
  );
};

export default AreaSelection;
